import React from 'react'

interface PlusMinusWrapperProps {
  className?: string
  name?: string
  value: number | string | null | undefined
  step?: number
  // The floor the minus button stops at. Clamping here rather than in each
  // consumer keeps the stepper from emitting a value the consumer rejects --
  // a rejected value re-renders nothing, so the field would freeze at the last
  // accepted number while further clicks drifted further out of range.
  min?: number
  onChange: (name: string, value: number) => void
  children: React.ReactNode
}

const PlusMinusWrapper = ({
  className = '',
  name = '',
  value,
  step = 1,
  min = 0,
  onChange,
  children
}: PlusMinusWrapperProps) => {
  // Number() rather than the raw prop: consumers that bind a text input pass a
  // string, and '100' + 10 concatenates to 10010.
  const parsed = Number(value)
  const current = Number.isFinite(parsed) ? parsed : min

  // handle floating point number precision rounding error
  const stepped = (delta: number) => parseFloat((current + delta).toFixed(4))

  const handlePlus = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    onChange(name, stepped(step))
  }

  const handleMinus = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    onChange(name, Math.max(min, stepped(-step)))
  }

  return (
    <div className={`plus-minus-input ${className}`}>
      <button type='button' className='minus-button' onClick={handleMinus}>
        -
      </button>
      {children}
      <button type='button' className='plus-button' onClick={handlePlus}>
        +
      </button>
    </div>
  )
}

export default PlusMinusWrapper
